 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		12: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		12: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"606041e6852125975c0be391352d69efa2ec35bb","2":"styles","3":"36424bddcb4cd119f920f7ace5aa8f5a03f106fc","4":"c483bb3c5bb85bc3f9772042239943dabaf727c7","5":"14291e0a358b1bbe2df495a270b15fbc3f1e0a71","6":"212b0ce736cbc98d94156def9adb515b69e084bb","7":"00e6c4c152e92fd3f9d565d64a6c06157792d35c","8":"384de54c5b6baa4a6f8c34c59b739a412ad2b783","9":"a803f5bd507e742a573f315a1c6a4649b18c9e6d","10":"44ce614c898c9093aaecde572b154ca5adf2d587","11":"6aed798e4a9f5a25da2f7133bc6e304ea4e827f5","13":"8233f44c","15":"component---src-pages-404-js","16":"component---src-pages-about-jsx","17":"component---src-pages-apps-jsx","18":"component---src-pages-contact-jsx","19":"component---src-pages-dictionary-index-jsx","20":"component---src-pages-exam-index-jsx","21":"component---src-pages-exam-list-jsx","22":"component---src-pages-exam-organizations-jsx","23":"component---src-pages-exam-question-jsx","24":"component---src-pages-faq-jsx","25":"component---src-pages-files-index-jsx","26":"component---src-pages-files-list-jsx","27":"component---src-pages-forum-index-jsx","28":"component---src-pages-forum-list-jsx","29":"component---src-pages-forum-question-jsx","30":"component---src-pages-hints-index-jsx","31":"component---src-pages-index-tsx","32":"component---src-pages-library-index-jsx","33":"component---src-pages-library-law-jsx","34":"component---src-pages-library-laws-jsx","35":"component---src-pages-library-rule-jsx","36":"component---src-pages-library-rules-library-jsx","37":"component---src-pages-library-rules-qa-afzoodeh-jsx","38":"component---src-pages-library-rules-qa-market-jsx","39":"component---src-pages-library-rules-qa-mostagim-jsx","40":"component---src-pages-me-bought-index-jsx","41":"component---src-pages-me-library-jsx","42":"component---src-pages-me-news-jsx","43":"component---src-pages-me-notes-jsx","44":"component---src-pages-me-tickets-jsx","45":"component---src-pages-me-todos-jsx","46":"component---src-pages-news-index-jsx","47":"component---src-pages-pre-jsx","48":"component---src-pages-privacy-jsx","49":"component---src-pages-services-index-jsx","50":"component---src-pages-system-jsx","51":"component---src-pages-user-code-confirm-jsx","52":"component---src-pages-user-login-jsx","53":"component---src-pages-user-notifs-jsx","54":"component---src-pages-user-profile-jsx"}[chunkId]||chunkId) + "-" + {"0":"c5c1aa03a82c1f9115c3","1":"4949823f31fdd31472f6","2":"7d4153d260c0197f0043","3":"a9197f01cd3069dbbf58","4":"d3e84dc24d770f04ea1f","5":"a087a49e6fbbe78441a0","6":"9aa521868a13fa854597","7":"0620f20f54e9c50d78fe","8":"fa5cd89392012e673896","9":"023d9b872c7abaf6dcf0","10":"1b4036c9ca90cec37a38","11":"70f39b0b8b48cc196017","13":"9ccd51c5b2b7c488b395","15":"1dfed8df3107ccfa62ce","16":"e813fa18cb8f6559b160","17":"28056f75b07860f4fc24","18":"6f9c0428c8af456d639a","19":"06bbcc0a570845674c5c","20":"3e338cbc778a8e61e191","21":"9b8a102f72212b9c2d0f","22":"4a42975c47c685b51b30","23":"99f72a8bd3d4b84ae171","24":"2ec476e4b752b92c790e","25":"6a04ccd744f3661478d6","26":"99b731fcca225b13d14e","27":"9b2eb7574ea9634d4a3d","28":"f916b186f0f08d3d77c5","29":"3138a8d7c4cbd441a152","30":"11ea060573b9fec02945","31":"9ab8082e030ab58e6a63","32":"d70a5a89d8eddd3e9141","33":"0e925158b9cbdc58b94a","34":"3cac39ef8e73a72421b0","35":"5874d61827b78eb19454","36":"49adf6644436202f049d","37":"d3004188de0caa4a17d7","38":"847877fa3ae8ac774a45","39":"1cf350dc375d2180732c","40":"3afdd7443db58426e4ed","41":"dbf60e543e4f3ac9f3f5","42":"a4b1f440652091a3c64e","43":"f20c88c817a05daf8c84","44":"e5ac4d058db4c0e86568","45":"0e3c7e028ffd67fbaacf","46":"faae999266d783fe254e","47":"cd6d012dac60e3dd3304","48":"f337d8e85b0e3a7b9e86","49":"9415c25c60f5544de437","50":"7251dd720f23039508fd","51":"2ace425dec4b9b5f7bf8","52":"0c536dfa06e11dc7a949","53":"40e4eccbb8ec49b8fcb8","54":"5788b08ecf949e8ffcdc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"606041e6852125975c0be391352d69efa2ec35bb","2":"styles","3":"36424bddcb4cd119f920f7ace5aa8f5a03f106fc","4":"c483bb3c5bb85bc3f9772042239943dabaf727c7","5":"14291e0a358b1bbe2df495a270b15fbc3f1e0a71","6":"212b0ce736cbc98d94156def9adb515b69e084bb","7":"00e6c4c152e92fd3f9d565d64a6c06157792d35c","8":"384de54c5b6baa4a6f8c34c59b739a412ad2b783","9":"a803f5bd507e742a573f315a1c6a4649b18c9e6d","10":"44ce614c898c9093aaecde572b154ca5adf2d587","11":"6aed798e4a9f5a25da2f7133bc6e304ea4e827f5","13":"8233f44c","15":"component---src-pages-404-js","16":"component---src-pages-about-jsx","17":"component---src-pages-apps-jsx","18":"component---src-pages-contact-jsx","19":"component---src-pages-dictionary-index-jsx","20":"component---src-pages-exam-index-jsx","21":"component---src-pages-exam-list-jsx","22":"component---src-pages-exam-organizations-jsx","23":"component---src-pages-exam-question-jsx","24":"component---src-pages-faq-jsx","25":"component---src-pages-files-index-jsx","26":"component---src-pages-files-list-jsx","27":"component---src-pages-forum-index-jsx","28":"component---src-pages-forum-list-jsx","29":"component---src-pages-forum-question-jsx","30":"component---src-pages-hints-index-jsx","31":"component---src-pages-index-tsx","32":"component---src-pages-library-index-jsx","33":"component---src-pages-library-law-jsx","34":"component---src-pages-library-laws-jsx","35":"component---src-pages-library-rule-jsx","36":"component---src-pages-library-rules-library-jsx","37":"component---src-pages-library-rules-qa-afzoodeh-jsx","38":"component---src-pages-library-rules-qa-market-jsx","39":"component---src-pages-library-rules-qa-mostagim-jsx","40":"component---src-pages-me-bought-index-jsx","41":"component---src-pages-me-library-jsx","42":"component---src-pages-me-news-jsx","43":"component---src-pages-me-notes-jsx","44":"component---src-pages-me-tickets-jsx","45":"component---src-pages-me-todos-jsx","46":"component---src-pages-news-index-jsx","47":"component---src-pages-pre-jsx","48":"component---src-pages-privacy-jsx","49":"component---src-pages-services-index-jsx","50":"component---src-pages-system-jsx","51":"component---src-pages-user-code-confirm-jsx","52":"component---src-pages-user-login-jsx","53":"component---src-pages-user-notifs-jsx","54":"component---src-pages-user-profile-jsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"a93da07693eaed5b3a98","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
